const StoxxoSection = () => {
  return (
    <section className="about about--style1 bg-color xts-section">
      <div className="container">
        <div className="about__wrapper">
          <div className="row gx-5 gy-4 gy-sm-0 align-items-center">
            <div className="col-lg-6">
              <div className="about__thumb pe-lg-5" data-aos="fade-right" data-aos-duration="800">
                <div className="about__thumb-inner">
                  <div className="about__thumb-image floating-content">
                    <img className="dark" src="/assets/images/new/stoxxo.jpg" alt="Stoxxo Trading " />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="about__content" data-aos="fade-left" data-aos-duration="800">
                <div className="about__content-inner">
                  <h2 className="meet-oppurtanity">Stoxxo / <span className="style2">Algo baba </span></h2>

                  <p>
                    A platform that allows to bring Your Option Strategies to Life with Inbuilt Advanced options Module with Endless Possibilities Manage Your Time Based Multi leg straddles a Butterfly, Iron Condor or Your Custom Strategy to Life 
                    </p>
                  <p>
                    If you a Heavy Quantity Trader Then the Order Slicing covers you Up and Handle Orders Efficiently Easily Create your option Strategy
                    </p>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </section>
  );
};

export default StoxxoSection;